import React, {useContext, useEffect, useState} from 'react';
import {Button, Form, Modal, Table, Tag} from 'antd';
import Rebut from "../../../../model/multilleure/rebuts/Rebut";
import {AuthContext} from "../../../../config/AuthContext";
import {ColumnsType, TableProps} from "antd/es/table";
import {PostInscripcionsFiltrat} from "../../../../dao/multilleure/casals/PostInscripcionsFiltrat";
import Colors from "../../../../styles/Colors";
import {BsEye} from "react-icons/bs";
import {useNavigate} from "react-router-dom";

interface IngredientModalProps {
    element: Rebut | undefined;
    visible: boolean;
    onClose: (value: boolean) => void;
}

const InscripcionsContactesModal: React.FC<IngredientModalProps> = ({element, visible, onClose}) => {
    const [form] = Form.useForm();
    const [IBAN, setIBAN] = useState("");
    const [isRd, setIsRd] = useState<boolean>(false);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [activitats, setActivitats] = useState<any>([]);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    async function checkDades() {
        const dades = await PostInscripcionsFiltrat({idUsuari: element?.id_contacte}, page);
        setActivitats(dades);
    }

    useEffect(() => {
        checkDades()
    }, []);


    function handleCancel() {
        onClose(false);
    }

    function veureInscrpcio(ele: any) {
        console.log(">>>>>:"+JSON.stringify(ele));
        navigate(`/multilleure/inscripcions/${element?.id_contacte}/activitat/${ele.id_activitat}`);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            defaultSortOrder: 'descend',
            width: 5,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'pagador',
            title: 'Pagador',
            dataIndex: 'pagador',
            width: 100,
            responsive: ['lg'],
        },
        {
            key: 'activitat',
            title: 'Activitat',
            dataIndex: 'activitat',
            width: 100,
            responsive: ['lg'],
        },
        {
            key: 'veure',
            title: 'Visualitzar',
            dataIndex: 'veure',
            width: 100,
            render: (estat, ele) => (
                <Button title={"Veure Insripcions"} style={{backgroundColor: Colors.colors.color4}}
                        onClick={() => veureInscrpcio(ele)}
                ><BsEye/></Button>
            ),
        }
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    return (
        <Modal
            title="Inscripcions"
            open={visible}
            footer={[]}
            width={1000}
            onCancel={handleCancel}
        >
            <Table
                {...tableProps}
                columns={columns}
                dataSource={activitats}
            />
        </Modal>
    );
};

export default InscripcionsContactesModal;
